export const COUPONS_IN_CART = 'coupons-in-cart';

export const COUNT_IN_CART = 'count-in-cart';
